import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Cake from '@material-ui/icons/Cake';

import ORTypography from 'components/ORTypography/ORTypography';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  status: PropTypes.string.isRequired,
  discount: PropTypes.number.isRequired,
  dtCreated: PropTypes.string.isRequired,
  trialCreditCents: PropTypes.number,
  billingSetupComplete: PropTypes.bool,
};

const defaultProps = {
  trialCreditCents: 0,
  billingSetupComplete: false,
};

export function UnstyledPromotionItem({
  classes,
  status,
  discount,
  dtCreated,
  trialCreditCents,
  billingSetupComplete,
}) {
  const expirationDate = moment(dtCreated).add(1, 'years').format('MM/DD/YY');
  const currentDate = moment().format('MM/DD/YY');
  const expired = moment(currentDate).isAfter(expirationDate);
  const trialCreditDollars = trialCreditCents > 0 ? trialCreditCents / 100 : 0;

  return billingSetupComplete || discount ? (
    <TableRow>
      <TableCell classes={{ root: classes.tableCellRoot }}>
        <Cake className={classes[expired ? 'promotionExpired' : 'promotion']} fontSize="large" />
      </TableCell>
      <TableCell classes={{ root: classes.infoCellRoot }}>
        <ORTypography
          align="left"
          component="p"
          className={classes[expired ? 'promotionExpired' : 'promotion']}
        >
          {status}
        </ORTypography>
        <ORTypography align="left" component="p" className={classes.discountInfo}>
          {discount ? (
            <React.Fragment>
              <span className={classes.discount}>
                Discount&nbsp;
                {discount}%
              </span>
              <br />
              <span className={classes.expiration}>
                {expired ? 'Expired: ' : 'Expires: '}
                {expirationDate}
              </span>
            </React.Fragment>
          ) : (
            <span className={classes.discount}>
              Balance: ${trialCreditDollars}
              &nbsp;out of $200
            </span>
          )}
        </ORTypography>
      </TableCell>
      <TableCell classes={{ root: classes.tableCellRoot }} />
    </TableRow>
  ) : (
    <TableRow>
      <TableCell classes={{ root: classes.tableCellRoot }} />
      <TableCell classes={{ root: classes.noPaymentCellRoot }}>
        <ORTypography align="center" component="p" className={classes.noPaymentMsg}>
          Activate your $200 in Free Credits by entering your Credit Card.
        </ORTypography>
      </TableCell>
      <TableCell classes={{ root: classes.tableCellRoot }} />
    </TableRow>
  );
}

UnstyledPromotionItem.propTypes = propTypes;
UnstyledPromotionItem.defaultProps = defaultProps;

const styles = (theme) => ({
  noPaymentContainer: {
    padding: theme.spacing(2),
  },
  noPaymentMsg: {
    fontSize: '12px',
    fontStyle: 'italic',
    color: '#4A4A4A',
  },
  promotion: {
    color: theme.customColors.black,
  },
  promotionExpired: {
    color: theme.customColors.mediumGrey,
  },
  discountInfo: {
    lineHeight: '1.1rem',
  },
  discount: {
    color: theme.palette.secondary.main,
    fontSize: '14px',
  },
  expiration: {
    color: theme.customColors.mediumGrey,
    fontSize: '12px',
  },
  infoCellRoot: {
    padding: theme.spacing(0.5),
  },
  noPaymentCellRoot: {
    padding: theme.spacing(1.5),
  },
  tableCellRoot: {
    width: '50px',
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
});

export default withStyles(styles)(UnstyledPromotionItem);
